<template>
  <b-sidebar id="sidebar" shadow lazy v-model="visible">
    <div class="sidebar-content">
      <div class="gyra-banner-container">
        <img
          src="../../assets/images/gyra_banner/gyra_banner@3x.png"
          alt="Gyra Banner"
          class="gyra-banner"
        />
      </div>

      <div class="action-group"></div>
      <search-bar
        class="search-box hidden"
        is-mobile
        v-model="searchTerm"
        @change="applySearch"
        @input="applySearch"
        :placeholder="'header.search' | translate"
      />

      <div class="sex-selector-container">
        <sex-selector />
      </div>

      <div class="navigation">
        <div
          class="nav-item-container"
          v-for="(navItem, i) in getNavItemsMobile"
          :key="i"
          @click="handleNavClick(navItem)"
        >
          <div class="nav-item-row">
            <p
              class="nav-item"
              :class="{
                'nav-item--selected': isCurrentNav(navItem),
                'nav-item--highlighted': isHighlightedNav(navItem)
              }"
            >
              {{ `header.${navItem.name}` | translate | uppercase }}
            </p>
            <BIcon
              v-if="navItem.hasSubNav"
              icon="chevron-down"
              class="nav-arrow"
              :class="{ 'nav-arrow--open': isOpen(navItem) }"
            ></BIcon>
          </div>
          <div class="nav-item-dropdown" v-if="isOpen(navItem)">
            <p
              v-for="(subNav, i) in subNavs"
              :key="i"
              @click="onSubNavClick(subNav)"
            >
              {{ `filter.type.${subNav}` | translate | capitalize }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </b-sidebar>
</template>

<script>
import { sexNavigation } from "../../mixins";
import { categoryNavigation } from "../../mixins";
import SearchBar from "../atoms/search-bar";
import SexSelector from "../atoms/sex-selector";
import { BIcon } from "bootstrap-vue";
import { getPossibleFilterValues } from "../../services/api";
import { mapMutations } from "vuex";
import { productTypeNavigation } from "../../mixins/navigation/productTypeNavigation";

export default {
  name: "the-sidebar",
  components: { SexSelector, SearchBar, BIcon },
  mixins: [sexNavigation, categoryNavigation, productTypeNavigation],
  data() {
    return {
      searchTerm: null,
      openNavItem: null,
      subNavs: [],
      visible: null
    };
  },
  methods: {
    closeSidebar() {
      this.visible = false;
    },
    async applySearch() {},
    isOpen(navItem) {
      return this.openNavItem === navItem;
    },
    async handleNavClick(navItem) {
      if (navItem.hasSubNav) {
        await this.getSubNavs(navItem);
        this.setOpenOrToggle(navItem);
      } else {
        this.closeSidebar();
        this.navigateToCategory(navItem);
      }
    },
    setOpenOrToggle(navItem) {
      if (this.isOpen(navItem)) {
        this.openNavItem = null;
      } else {
        this.openNavItem = navItem;
      }
    },
    async getSubNavs(navItem) {
      let query = {
        sex: this.$route.params.sex
      };

      if (navItem.name === "sale") {
        query = { ...query, onSale: true };
      } else {
        query = { ...query, category: navItem.name };
      }

      const response = await getPossibleFilterValues("type", query);
      if (response.status === 200) {
        this.subNavs = response.data;
      } else {
        this.handleHttpError(response);
      }
    },
    onSubNavClick(subNavItem) {
      this.resetProducts();
      this.resetCommons();
      this.setSubNavItemWithFilter(subNavItem);
      this.navigateToCategory(this.openNavItem);
      this.closeSidebar();
    },
    ...mapMutations({
      setSubNavItem: "navigation/setCurrentSubNavItem",
      resetProducts: "overview/reset",
      resetCommons: "filters/resetCommons"
    })
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/global.scss";
.sidebar-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-left: 23px;
  padding-right: 23px;
}
.gyra-banner {
  width: 102px;
  height: 36px;
}
.gyra-banner-container {
  width: 100%;
  display: flex;
  justify-content: center;
}
.search-box {
  width: 100%;
  height: 42px;
  margin-top: 30.9px;
}

.sex-selector-container {
  width: 180px;
  height: 34px;
  margin-top: 33.5px;
  margin-right: auto;
}

.navigation {
  width: 100%;

  p {
    font-size: 14px;
    cursor: pointer;
  }
}
.nav-item-container {
  display: flex;
  flex-direction: column;
}
.nav-item-row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.nav-item {
  margin-top: 40px;
  margin-bottom: 0;
}
.nav-arrow {
  margin-top: 40px;
  margin-bottom: 0;
  transition: transform 0.25s ease;
}
.nav-arrow--open {
  transform: rotate(180deg);
  transition: transform 0.25s ease;
}
.nav-item--selected {
  font-weight: bold;
}
.nav-item--highlighted {
  color: $gyra-red;
}

.nav-item-dropdown {
  p {
    margin: 20px 0 0 50px;
  }
}

.hidden {
  display: none;
}
</style>

<style lang="scss">
.b-sidebar {
  width: 414px;
}
</style>
